import { RefinementList, useInstantSearch } from 'react-instantsearch'

import type { ReactElement } from 'react'
import type { RefinementListProps } from 'react-instantsearch'

import Label from '~/components/Label'

import './styles.scss'

export interface Props extends RefinementListProps {
  label: string
  labelFormatter?: (label: string) => string
}

const AlgoliaRefinementList = ({ label, ...props }: Props): ReactElement => {
  const {
    results: { disjunctiveFacets },
  } = useInstantSearch()

  const facetExists = (facetName: string) => disjunctiveFacets.some(({ name }) => name === facetName)

  return (
    <div className="custom-refinement-list-container">
      <Label className="index-label" label={label} />
      <RefinementList
        {...props}
        className="custom-refinement-list"
        classNames={{
          checkbox: 'custom-refinement-list__checkbox',
          count: 'custom-refinement-list__count',
          item: 'custom-refinement-list__item',
          label: 'custom-refinement-list__label',
          list: 'custom-refinement-list__list',
        }}
      />
      {!facetExists(props.attribute) && <span className="custom-refinement-list__no-results">No results.</span>}
    </div>
  )
}

export default AlgoliaRefinementList
